<template>
  <section>
    <div id="contactCont" :class="{'cont-active': zoneIsActive, 'cont-deactive': zoneNotActive}">
      <h2 :class="{'h2-active': zoneIsActive, 'h2-deactive': zoneNotActive}"><span>CONTACT</span> US</h2>
      <div id="formCont">
        We're still working on this portion of the site. Please check back with us soon!
      </div>
    </div>
  </section>
</template>

<script>
  
  export default {
    name: 'ContactSection',
    
    components: {
      
    },
    
    data() {
      return {
        
      }
    },
    
    computed: {
      zoneIsActive() {
        return this.$store.state.activeSections.contact;
      },
      zoneNotActive() {
        return !this.$store.state.activeSections.contact;
      }
    },
    
    methods: {
      
    }
  }
  
</script>

<style scoped>
  section {
    width: 100%;
    min-width: 320px;
    min-height: 100vh;
    border: solid blue 0px;
    display: flex; 
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: var(--bg-main);
    transition: background-position, 400ms;
  }
  
  #contactCont {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: dashed green 0px;
    transition: opacity 300ms cubic-bezier(.47,0,.2,1);
  }
  
  #formCont {
    min-height: 300px;
    width: 100%;
    margin: 0px 50px 0px 50px;
    padding: 30px;
    border: solid green 0px;
    text-align: center;
  }
  
  .cont-active {
    opacity: 1;
  }
  
  .cont-deactive {
    opacity: 0;
  }
  
  span {
    color: rgb(168, 59, 246);
    font-weight: bold;
  }

  h2 {
    font-family: Futura,Trebuchet MS,Arial,sans-serif;
    font-weight: normal;
    font-size: 34px;
    border: solid yellow 0px;
    position: relative;
    color: rgb(255,255,255);
    text-shadow: 0px 2px 4px rgba(0, 0, 0, .2);
    margin: 40px 0px 40px 0px;
    transition: all 500ms cubic-bezier(.47,0,.2,1);
  }
  
  .h2-active {
    opacity: 1;
    transform: scale(1);
  }
  
  .h2-deactive {
    opacity: 0;
    transform: scale(.8);
  }
  
  @media screen and (max-width: 800px) {
    
  }
  
  @media screen and (max-width: 450px) {
    h2 {
      font-size: 7vw;
      text-align: center;
      margin: 20px 0px 40px 0px;
    }
  }
  
</style>